import { combineReducers } from "@reduxjs/toolkit";
import sessionReducer from "../sessionSlice";
import analyticsReducer from "./Contact/analyticsSlice";
import contactPayloadReducer from "./Contact/contactPayloadSlice";
import contactTypeReducer from "./Contact/contactTypeSlice";
import generalDetailsReducer from "./Contact/generalDetailsSlce";
import phoneNoReducer from "./Contact/phoneNoSlice";

export const rootReducer = combineReducers({
  sessionData: sessionReducer,
  analyticsData: analyticsReducer,
  contactPayloadData: contactPayloadReducer,
  contactType: contactTypeReducer,
  contactGeneralDetails: generalDetailsReducer,
  phoneNo: phoneNoReducer,
});
